import { fedopsLogger } from '#packages/util';
import { MigrationFlow } from '../types';

export const getFedopsInteractionKey = (flow: MigrationFlow) =>
  flow === MigrationFlow.PerPageEditor || flow === MigrationFlow.PerPageADI
    ? fedopsLogger.INTERACTIONS.SECTIONS_MIGRATION.PAGE_MIGRATION
    : fedopsLogger.INTERACTIONS.SECTIONS_MIGRATION.BULK_MIGRATION;
